import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// French typography: keep punctuation (? ! ; : ») attached to the preceding
// word by turning the space before it into a non-breaking space, so it never
// wraps onto its own line. Length is preserved (1-char swap) so karaoke char
// indices stay aligned.
export function frenchTypography(text) {
  if (!text) return text;
  return text.replace(/ ([?!;:»])/g, ' $1');
}
